import styled from 'styled-components';

import { Dropdown } from '@honeycomb-npm/honeycomb-react';

import GridContainer from './layout/grid';
import Tips from './Tips';
import {
    Alignment,
    DropdownBoxSize,
    OptionValue,
} from './types';
import { AddElementFunction, DropDownOptions } from '../../types';

export * from './types';

interface IUploadItem {
    alignment: keyof typeof Alignment;
}

export interface IUploadDropdownType extends IUploadItem {
    id: string;
    name: string;
    label: string;
    dropdownTipsContent: string;
    defaultOption?: string;
    errormessage?: string;
    options: DropDownOptions<string>[];
    helpText?: string;
    formValue: DropDownOptions<string>;
    handleChange: (props: OptionValue) => void;
    size: 'fullSize' | 'halfSize' | 'smallSize';
    showIcon?: boolean;
    iconSymbol?: string;
    isValid?: boolean;
    iconType?: 'svgfile' | 'svginline' | 'css' | 'iconfont';
    dropdownRef?: AddElementFunction;
}

const Container = styled(GridContainer)<IUploadItem>`
    grid-template-columns: ${(props) =>
        props.alignment === Alignment.top || props.alignment === Alignment.bottom
            ? 'auto'
            : 'repeat(2, 1fr)'};

    div:nth-child(1) {
        order: ${(props) =>
        props.alignment === Alignment.top || props.alignment === Alignment.left ? 2 : 1};
    }
    div:nth-child(2) {
        order: ${(props) =>
        props.alignment === Alignment.top || props.alignment === Alignment.left ? 1 : 2};
    }
    row-gap: ${(props) =>
        props.alignment === Alignment.top ? '2rem' : 0};
    column-gap: 2rem;
    padding-top: 0.25rem;

    label {
        padding-bottom: 0.625rem;
    }
`;

export const DropdownWithTips = ({
    alignment,
    id,
    label: labelName,
    defaultOption,
    errormessage,
    options,
    helpText,
    formValue,
    handleChange,
    name,
    size,
    showIcon,
    iconSymbol,
    iconType,
    dropdownTipsContent,
    isValid,
    dropdownRef,
}: IUploadDropdownType) => (
    <Container alignment={alignment} >
        <GridContainer columns={ DropdownBoxSize[size].toString() ?? DropdownBoxSize.fullSize.toString() }>
            {
                <Dropdown
                    id={id}
                    defaultOption={defaultOption}
                    errormessage={errormessage}
                    options={options}
                    onChange={(label: string, value: string) => handleChange({ label, value })}
                    name={name}
                    label={labelName}
                    helptext={helpText}
                    value={formValue.value ?? ''}
                    hideDefaultOption={!!formValue.value}
                    isValid={isValid}
                    ref={dropdownRef}
                    required
                />
            }

        </GridContainer>
        {dropdownTipsContent !== '' && (
            <Tips showIcon={showIcon} iconSymbol={iconSymbol} iconType={iconType} formValue={formValue} dropdownTipsContent={dropdownTipsContent} />
        )}
    </Container>
);
